export default __webpack_public_path__ + "static/media/errorMB.632029a2.png";